<ion-list class="background-spacer">
  <ion-list-header>Settings</ion-list-header>
  <ion-item *ngIf="!isSignedIn" button (click)="menuChoice('copy-kiosk-users')">
    <ion-text color="warning">Copy Kiosk Users</ion-text>
    <ion-icon color="warning" slot="start" name="cloud-download-outline"/>
  </ion-item>
  <ion-item button [disabled]="!isSignedIn" (click)="menuChoice('nav:user-info')">
    <ion-icon slot="start" name="information-circle-outline"/>
    <ion-text>User Info</ion-text>
  </ion-item>
  <ion-item *ngIf="isKioskMode && !isSignedIn" button (click)="menuChoice('add-kiosk-user')">
    <ion-icon slot="start" name="person-add-outline" color="success"/>
    <ion-text color="success">Add/Renew Kiosk User</ion-text>
  </ion-item>
  <ion-item *ngIf="!isKioskMode && isSignedIn" button (click)="menuChoice('toggle-manual-mode')">
    <ion-icon
      slot="start"
      [name]="manualOffline ? 'cloud-done-outline' : 'cloud-offline-outline'"
      [color]="manualOffline ? 'success' : 'warning'"
    />
    <ion-text>Work {{ manualOffline ? 'Online' : 'Offline' }}</ion-text>
  </ion-item>
</ion-list>
